module.exports = __webpack_public_path__ + "media/newstyle/images/icon-arrow-right-pagination-9e7da2d871cfb35512eb4262d33b8d1f.svg";